import TrustedDevicesDialog from './TrustedDevicesDialog';

export default TrustedDevicesDialog;
